import isEmpty from "../../../../common/helpers/isEmpty";
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { leadingZerosDateFormat } from "../../../../common/helpers/formatDateTime";
import { EmploymentSalaryRow, ShiftSalaryRow } from "../../types/common";
import { useTranslation } from "react-i18next";

type Props = {
  row: ShiftSalaryRow | EmploymentSalaryRow;
  open: boolean;
  afterRaiseDateSalaryPerDateKeys: string[];
};

const BulkSalaryIncreaseCollapsedRows = ({
  row,
  open,
  afterRaiseDateSalaryPerDateKeys,
}: Props) => {
  const { t } = useTranslation();

  if (isEmpty(row.afterRaiseSalaryPerDate)) return null;

  const colSpan = 100;

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={colSpan}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box sx={{ margin: "16px 8px" }}>
            <Typography
              variant="header"
              fontSize="18px"
              gutterBottom
              component="div"
            >
              {t("settings:bulkSalaryIncrease.futureSalaries")}
            </Typography>
            <Table size="small" sx={{ width: "auto" }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ padding: "6px 16px 6px 0px" }}>
                    {t("common:date")}
                  </TableCell>
                  {afterRaiseDateSalaryPerDateKeys.map((key) => (
                    <TableCell key={key} align="right">
                      {key}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {row.afterRaiseSalaryPerDate.map((salaryItem, i) => (
                  <TableRow key={i}>
                    <TableCell sx={{ padding: "6px 16px 6px 0px" }}>
                      {format(
                        new Date(salaryItem.date),
                        leadingZerosDateFormat,
                      )}
                    </TableCell>
                    {afterRaiseDateSalaryPerDateKeys.map((key, j) => (
                      <TableCell key={j} align="right">
                        {salaryItem.salary[key] || "-"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default BulkSalaryIncreaseCollapsedRows;
